<template>
  <div>
    <div>
      <div class="page-title-cont">
        <h1 class="wp-heading-inline">
          WPCal.io - {{ T__("Calendar Settings") }}
        </h1>
        <AdminHeaderRight />
      </div>
      <SettingsMenu />
      <OnBoardingCheckList display_in="settings_calendars" />
      <div class="col-cont settings-cont">
        <div class="col">
          <div class="form">
            <div class="wpc-form-row">
              <label style="display: flex;align-items: center;"
                >{{ T__("My calendar accounts") }}
                <a
                  href="https://help.wpcal.io/en/article/calendar-integrations-4et2xz/?utm_source=wpcal_plugin&utm_medium=contextual"
                  target="_blank"
                  class="icon-q-mark"
                  style="margin-top:-2px;"
                ></a>
                <PremiumInfoBadge
                  style="margin: -50px 0px 0px 10px;"
                  highlight_feature="calendars"
                >
                  <em>Free: 1 calendar account<br />Plus: Unlimited</em>
                </PremiumInfoBadge>
              </label>
              <div class="mbox cal-accs">
                <div class="connected-accounts-cont">
                  <div
                    class="connected-account"
                    v-for="(calendar_account, index) in calendar_accounts"
                    :key="index"
                    :class="{
                      [calendar_account.provider]: true,
                      'del-alert': show_delete_highlight(
                        'disconnect_highlight_calendar_account_index',
                        index
                      ),
                      'status-disconnected': calendar_account.status == -5
                    }"
                  >
                    <div class="txt-h5">
                      <div class="app-name">
                        {{ calendar_account.provider | calendar_provider_name }}
                      </div>
                      <div class="account-connection-actions">
                        <OverflowMenu
                          :menu_id="calendar_account.id"
                          v-model="calendar_account_overflow_menu_details"
                        >
                          <a
                            class="menu-item hover-hl"
                            v-if="calendar_account.status == -5"
                            @click="
                              add_calendar_account(
                                calendar_account.provider,
                                'reauth'
                              )
                            "
                            >Reconnect</a
                          >
                          <a
                            class="menu-item del-hl"
                            style="color:#e84653; font-size: 12px;"
                            @click="
                              calendar_account_overflow_menu_details.open_menu_id = null;
                              show_disconnect_confirmation(calendar_account);
                            "
                            @mouseover="
                              set_mouseover_on_delete(
                                'disconnect_highlight_calendar_account_index',
                                index,
                                true
                              )
                            "
                            @mouseleave="
                              set_mouseover_on_delete(
                                'disconnect_highlight_calendar_account_index',
                                index,
                                false
                              )
                            "
                            >{{
                              calendar_account.status == "-5"
                                ? T__("Remove")
                                : T__("Disconnect")
                            }}</a
                          >
                        </OverflowMenu>

                        <span
                          class="status "
                          :class="{
                            enabled: calendar_account.status == '1',
                            disabled: calendar_account.status != '1'
                          }"
                          >{{
                            calendar_account.status == "1"
                              ? T__("Connected")
                              : T__("Disconnected")
                          }}</span
                        >
                      </div>
                    </div>
                    <div class="txt-help">
                      {{ calendar_account.account_email }}
                    </div>
                  </div>
                </div>
                <button
                  class="wpc-btn secondary md full-width"
                  @click="show_add_calandar_account_list = true"
                  v-if="!show_add_calandar_account_list"
                >
                  <!-- :disabled="!enable_add_new_calendar_account"
                  :title="
                    !enable_add_new_calendar_account
                      ? '6 calendar accounts is max limit'
                      : ''
                  " -->
                  {{ T__("+ Add Calendar Account") }}
                </button>
                <div v-if="show_add_calandar_account_list">
                  <div class="txt-h5 caps">
                    {{ T__("Select your calendar app") }}
                  </div>
                  <ul class="selector block cal_apps">
                    <li>
                      <label
                        @click="add_calendar_account('google_calendar')"
                        class="google_calendar"
                        >Google Calendar</label
                      >
                    </li>
                    <li class="disabled">
                      <label class="office365_calendar">
                        <em>Office 365</em>
                        <span>{{ T__("COMING SOON") }}</span>
                      </label>
                    </li>
                    <li class="disabled">
                      <label class="exchange_calendar">
                        <em>Exchange Calendar</em>
                        <span>{{ T__("COMING SOON") }}</span>
                      </label>
                    </li>
                    <li class="disabled">
                      <label class="outlook_calendar">
                        <em>Outlook Plug-in</em>
                        <span>{{ T__("COMING SOON") }}</span>
                      </label>
                    </li>
                    <li class="disabled">
                      <label class="icloud_calendar">
                        <em>iCloud Calendar</em>
                        <span>{{ T__("COMING SOON") }}</span>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <AdminInfoLine info_slug="ownership_settings_calendars" />
        </div>
        <div class="col">
          <div class="form">
            <div class="wpc-form-row">
              <label>{{ T__("Configuration") }}</label>
              <ul
                class="mbox"
                style="margin-top: 0;"
                id="calendar_cofiguration_cont"
                :class="{
                  'onboard-overlay-element': show_default_calendars_added_onboard
                }"
              >
                <li>
                  <div>
                    <div class="txt-h5 caps">
                      {{ T__("Add bookings to...") }}
                      <a
                        href="https://help.wpcal.io/en/article/calendar-integrations-4et2xz/?utm_source=wpcal_plugin&utm_medium=contextual#1-how-add-bookings-to-calendar-works"
                        target="_blank"
                        class="icon-q-mark"
                      ></a>
                    </div>
                    <div class="txt-help">
                      {{
                        T__(
                          "Set the calendar you would like to add new bookings to as they're scheduled."
                        )
                      }}
                    </div>
                    <div
                      class="cal-list cf p10 border-all border-round mt10"
                      @click="show_choose_add_bookings_to_calendar_modal"
                    >
                      <div
                        v-if="
                          calendar_accounts.hasOwnProperty(
                            add_bookings_to_calendar_account_id
                          )
                        "
                      >
                        {{ T__("Add to") }}
                        <span
                          class="cal-provider"
                          :class="
                            calendar_accounts[
                              add_bookings_to_calendar_account_id
                            ].provider
                          "
                        >
                          {{
                            calendar_accounts[
                              add_bookings_to_calendar_account_id
                            ].account_email
                          }}<a class="fl-rt">{{ T__("EDIT") }}</a></span
                        >
                        <ul class="bull">
                          <li>{{ add_bookings_to_calendar.name }}</li>
                        </ul>
                      </div>
                      <div v-else>
                        {{ T__("No calendar is choosen.")
                        }}<a class="fl-rt">{{ T__("EDIT") }}</a>
                      </div>
                    </div>
                    <div class="txt-help mt5">
                      {{
                        T__(
                          "This has to be set for Google Meet to work. When set, invitations and notifications will be sent to the invitee directly from your Google Calendar account."
                        )
                      }}
                    </div>
                    <modal
                      name="choose_add_bookings_to_calendar_modal"
                      @before-close="
                        can_show_choose_add_bookings_to_calendar_modal = false
                      "
                      height="auto"
                      width="360px"
                      style="z-index:9999;"
                    >
                      <div class="modal_close_cont">
                        <button
                          @click="
                            $modal.hide('choose_add_bookings_to_calendar_modal')
                          "
                        ></button>
                      </div>
                      <div
                        class="mbox bg-light shadow mb0"
                        v-if="can_show_choose_add_bookings_to_calendar_modal"
                      >
                        <div class="form">
                          <div class="wpc-form-row">
                            <label style="text-align:center;"
                              >Which calendar should we add<br />new events
                              to?</label
                            >
                            <ul class="selector block mt10 add-to-cal">
                              <li
                                v-for="(calendar_account,
                                index) in calendar_accounts"
                                :key="index"
                              >
                                <input
                                  type="radio"
                                  :id="'add-to-cal-opt' + index"
                                  name="add_bookings_to_calendar_account"
                                  :value="calendar_account.id"
                                  @change="
                                    choose_default_calendar_for_add_bookings_to
                                  "
                                  v-model="
                                    tmp_edit_add_bookings_to_calendar_account_id
                                  "
                                />
                                <label
                                  :for="'add-to-cal-opt' + index"
                                  :class="calendar_account.provider"
                                >
                                  {{ calendar_account.account_email }}</label
                                >
                              </li>

                              <li>
                                <input
                                  type="radio"
                                  id="add-to-cal-dont"
                                  name="add_bookings_to_calendar_account"
                                  value="no"
                                  v-model="
                                    tmp_edit_add_bookings_to_calendar_account_id
                                  "
                                />
                                <label for="add-to-cal-dont">{{
                                  T__("Do not add new bookings to any calendar")
                                }}</label>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <div
                          v-if="
                            calendar_accounts.hasOwnProperty(
                              tmp_edit_add_bookings_to_calendar_account_id
                            )
                          "
                        >
                          <div style="font-size: 14px; margin: 20px 0 5px;">
                            {{ T__("Add to Calendar") }}
                          </div>
                          <select
                            v-model="tmp_edit_add_bookings_to_calendar_id"
                          >
                            <option
                              v-for="(calendar, index) in this
                                .calendar_accounts[
                                tmp_edit_add_bookings_to_calendar_account_id
                              ].calendars"
                              :key="index"
                              :value="calendar.id"
                              :disabled="calendar.is_writable == '0'"
                              >{{ calendar.name }}</option
                            >
                          </select>
                        </div>
                        <button
                          type="button"
                          class="wpc-btn primary md mt20"
                          @click="update_add_bookings_to_calendar_id"
                        >
                          {{ T__("Update") }}
                        </button>
                      </div>
                    </modal>
                  </div>
                </li>
                <li>
                  <div>
                    <div class="txt-h5 caps">
                      {{ T__("Check for conflicts") }}
                      <a
                        href="https://help.wpcal.io/en/article/calendar-integrations-4et2xz/?utm_source=wpcal_plugin&utm_medium=contextual#1-how-check-for-conflicts-calendar-works"
                        target="_blank"
                        class="icon-q-mark"
                      ></a>
                    </div>
                    <div class="txt-help">
                      {{
                        T__(
                          "Set the calendar(s) to check and exclude slots already scheduled outside WPCal."
                        )
                      }}
                    </div>
                    <div>
                      <div
                        class="cal-list cf p10 border-all border-round mt10"
                        @click="
                          conflict_calendar_account_id = calendar_account.id;
                          show_choose_conflict_calendars_modal();
                        "
                        v-for="(calendar_account,
                        index) in conflict_calendar_accounts"
                        :key="index"
                      >
                        <div>
                          Check
                          <span
                            class="cal-provider"
                            :class="calendar_account.provider"
                          >
                            {{ calendar_account.account_email
                            }}<a class="fl-rt">{{ T__("EDIT") }}</a></span
                          >
                          <div
                            v-for="(calendar,
                            index2) in calendar_account.calendars"
                            :key="index2"
                          >
                            <ul class="bull">
                              <li>{{ calendar.name }}</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div
                        class="cal-list cf p10 border-all border-round mt10"
                        v-if="_isEmpty(conflict_calendar_accounts)"
                        @click="show_choose_conflict_calendars_modal"
                      >
                        <div>
                          {{ T__("No calendar is choosen.") }}
                          <a class="fl-rt">{{ T__("EDIT") }}</a>
                        </div>
                      </div>
                    </div>

                    <modal
                      name="choose_conflict_calendars_modal"
                      @before-close="
                        can_show_choose_conflict_calendars_modal = false
                      "
                      height="auto"
                      width="360px"
                      style="z-index:9999;"
                    >
                      <div class="modal_close_cont">
                        <button
                          @click="
                            $modal.hide('choose_conflict_calendars_modal')
                          "
                        ></button>
                      </div>
                      <div
                        class="mbox bg-light shadow"
                        v-if="can_show_choose_conflict_calendars_modal"
                      >
                        <div class="form">
                          <div class="wpc-form-row">
                            <label class="mb10" style="text-align:center;">{{
                              T__("Check for conflicts in...")
                            }}</label>
                            <select
                              v-if="calendar_accounts"
                              v-model="tmp_edit_conflict_calendar_account_id"
                            >
                              <option
                                v-for="(calendar_account, index) in this
                                  .calendar_accounts"
                                :key="index"
                                :value="calendar_account.id"
                                >{{ calendar_account.account_email }}</option
                              >
                            </select>

                            <div style="font-size: 14px; margin: 20px 0 5px;">
                              {{ T__("Check these calendars for conflicts") }}
                            </div>

                            <div v-if="tmp_edit_conflict_calendar_account_id">
                              <ul class="selector block mt10 check-conflicts">
                                <li
                                  v-for="(calendar, index) in calendar_accounts[
                                    tmp_edit_conflict_calendar_account_id
                                  ].calendars"
                                  :key="index"
                                >
                                  <input
                                    type="checkbox"
                                    :id="'check-conflicts-opt' + index"
                                    :value="calendar.id"
                                    v-model="tmp_edit_conflict_calendar_ids"
                                  />
                                  <label :for="'check-conflicts-opt' + index">{{
                                    calendar.name
                                  }}</label>
                                </li>
                              </ul>
                            </div>

                            <button
                              type="button"
                              class="wpc-btn primary md mt20"
                              @click="update_conflict_calendar_ids"
                            >
                              {{ T__("Update") }}
                            </button>
                          </div>
                        </div>
                      </div>
                    </modal>
                  </div>
                </li>
              </ul>
              <div
                id="calendar_cofiguration_cont_tip"
                class="onboard-overlay-popper popper-cont"
                :class="{
                  'popper-go-back':
                    show_default_calendars_added_onboard &&
                    (can_show_choose_add_bookings_to_calendar_modal ||
                      can_show_choose_conflict_calendars_modal)
                }"
                v-if="show_default_calendars_added_onboard"
                style="z-index:10000; width:360px;"
              >
                <div class="mbox shadow">
                  <div data-popper-arrow class="popper_arrow"></div>
                  We have automatically added your
                  {{
                    calendar_accounts[add_bookings_to_calendar_account_id]
                      .account_email
                  }}
                  account's primary calendar
                  <strong>{{
                    calendar_accounts[add_bookings_to_calendar_account_id]
                      .calendars[add_bookings_to_calendar_id].name
                  }}</strong>
                  to both 'Add bookings to...' and 'Check for conflicts'
                  options. <br /><br />You can change or remove this.<br /><br />
                  <div
                    style="background-color: #f9f5bf; color: #e19334; border: 1px dashed #e19334;padding: 8px 10px; border-radius: 5px;"
                  >
                    Important: Since the
                    <strong>{{
                      calendar_accounts[add_bookings_to_calendar_account_id]
                        .calendars[add_bookings_to_calendar_id].name
                    }}</strong>
                    calendar has been added to 'Check for conflits', time slots
                    of events in that calendar will be excluded from your
                    availability.
                  </div>
                  <button
                    style="margin-top: 10px;"
                    data-v-74b16bbd=""
                    type="button"
                    class="wpc-btn primary md"
                    @click="
                      can_close_default_calendars_added_onboard = true;
                      hide_default_calendars_added_onboard_modal();
                    "
                  >
                    Okay. Got it!
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <v-dialog /> -->
    <modal
      name="default_calendars_added_onboard_overlay"
      class="onboard-overlay"
      @before-close="before_close_default_calendars_added_onboard_modal"
    >
      <span></span>
    </modal>
  </div>
</template>

<script>
import SettingsMenu from "@/components/admin/SettingsMenu.vue";
import OnBoardingCheckList from "@/components/admin/OnBoardingCheckList.vue";

import OverflowMenu from "@/components/form_elements/OverflowMenu.vue";

import { createPopper } from "@popperjs/core";

import axios from "axios";

export default {
  components: {
    SettingsMenu,
    OnBoardingCheckList,
    OverflowMenu
  },
  props: {
    connect_status: {
      type: String,
      default: null
    },
    connected_calendar_account_id: {
      type: String,
      default: null
    },
    connected_calendar_default_calendars_added: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      document_title: "Calendars ‹ Settings",
      show_add_calandar_account_list: false,
      calendar_accounts: [],
      can_show_choose_add_bookings_to_calendar_modal: false,
      can_show_choose_conflict_calendars_modal: false,
      add_bookings_to_calendar_account_id: "no",
      add_bookings_to_calendar_id: "",
      tmp_edit_add_bookings_to_calendar_account_id: "no",
      tmp_edit_add_bookings_to_calendar_id: "",
      conflict_calendar_ids: [],
      conflict_calendar_account_id: "",
      tmp_edit_conflict_calendar_ids: [],
      tmp_edit_conflict_calendar_account_id: "",
      disconnect_highlight_calendar_account_index: null,
      connect_status_notified: false,
      show_default_calendars_added_onboard: false,
      default_calendars_added_onboard_popper_instance: null,
      can_close_default_calendars_added_onboard: false,
      calendar_account_overflow_menu_details: {
        open_menu_id: null,
        popper_instance: null
      }
    };
  },
  computed: {
    add_bookings_to_calendar() {
      if (
        this.add_bookings_to_calendar_account_id &&
        this.add_bookings_to_calendar_id
      ) {
        if (
          this.calendar_accounts.hasOwnProperty(
            this.add_bookings_to_calendar_account_id
          ) &&
          this.calendar_accounts[
            this.add_bookings_to_calendar_account_id
          ].calendars.hasOwnProperty(this.add_bookings_to_calendar_id)
        ) {
          return this.calendar_accounts[
            this.add_bookings_to_calendar_account_id
          ].calendars[this.add_bookings_to_calendar_id];
        }
      }
      return {};
    },
    conflict_calendar_accounts() {
      let conflict_calendar_accounts = {};
      for (let calendar_account_id in this.calendar_accounts) {
        for (let calendar_id in this.calendar_accounts[calendar_account_id]
          .calendars) {
          if (this.conflict_calendar_ids.indexOf(calendar_id) !== -1) {
            if (
              !conflict_calendar_accounts.hasOwnProperty(calendar_account_id)
            ) {
              conflict_calendar_accounts[calendar_account_id] = Object.assign(
                {},
                this.calendar_accounts[calendar_account_id]
              );
              conflict_calendar_accounts[calendar_account_id].calendars = {};
            }
            conflict_calendar_accounts[calendar_account_id].calendars[
              calendar_id
            ] = this.calendar_accounts[calendar_account_id].calendars[
              calendar_id
            ];
          }
        }
      }
      return conflict_calendar_accounts;
    },
    enable_add_new_calendar_account() {
      // let count = Object.keys(this.calendar_accounts).length;
      // if (count >= 6) {
      //   return false;
      // }
      return true;
    }
  },
  methods: {
    add_calendar_account(provider, do_ = "add") {
      let action = "add_calendar_account";
      if (do_ == "reauth") {
        action = "reauth_calendar_account";
      }
      if (provider === "google_calendar") {
        window.location =
          "admin.php?page=wpcal_admin&wpcal_action=" +
          action +
          "&provider=google_calendar";
      }
    },
    load_page() {
      let action = "get_calendar_accounts_details_of_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = {
        dummy__: ""
      };

      let action2 = "get_add_bookings_to_calendar_of_current_admin";
      wpcal_request[action2] = {
        dummy__: ""
      };

      let action3 = "get_conflict_calendar_ids_of_current_admin";
      wpcal_request[action3] = {
        dummy__: ""
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          let connect_status_notified = this.connect_status_notified;
          //Following commented for UI issue when popup opens before sync is done. As load page and sync happen in successions I belive it shouldn't create issue
          //Object.assign(this.$data, this.$options.data.apply(this)); //re-initilize data in Vue - this required as we are using this function to after update
          this.connect_status_notified = connect_status_notified;

          //console.log(response);
          if (
            response.data &&
            response.data[action].hasOwnProperty("calendar_accounts_details")
          ) {
            this.calendar_accounts =
              response.data[action].calendar_accounts_details;
            if (
              typeof response.data[action2] == "object" &&
              response.data[action2].hasOwnProperty(
                "add_bookings_to_calendar"
              ) &&
              response.data[action2].add_bookings_to_calendar &&
              response.data[action2].add_bookings_to_calendar.hasOwnProperty(
                "calendar_id"
              )
            ) {
              this.add_bookings_to_calendar_id =
                response.data[action2].add_bookings_to_calendar.calendar_id;
              this.add_bookings_to_calendar_account_id =
                response.data[
                  action2
                ].add_bookings_to_calendar.calendar_account_id;
            }
            this.conflict_calendar_ids =
              response.data[action3].conflict_calendar_ids;
            this.set_default_conflict_calendar_account_id();

            this.handle_connect_result();
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    handle_connect_result() {
      if (!this.connect_status || !this.connected_calendar_account_id) {
        return;
      }
      if (this.connect_status_notified) {
        return;
      }

      if (
        this.connect_status === "connected" &&
        !this._isEmpty(this.calendar_accounts)
      ) {
        for (let index in this.calendar_accounts) {
          if (
            this.calendar_accounts[index].id !=
            this.connected_calendar_account_id
          ) {
            continue;
          }

          let success_msg = this.Tsprintf(
            /* translators: 1: html-tag-open 2: html-tag-close 3: tp provider 4: account email */
            this.T__(
              "Your %1$s %3$s %2$s account %1$s %4$s %2$s is succesfully connected."
            ),
            "<strong>",
            "</strong>",
            this.$options.filters.calendar_provider_name(
              this.calendar_accounts[index].provider
            ),
            this.calendar_accounts[index].account_email
          );
          let success_title = "Ok";

          this.$toast.success(success_msg, success_title, {});

          if (this.connected_calendar_default_calendars_added) {
            setTimeout(() => {
              this.show_default_calendars_added_onboard_modal();
            }, 1200);
            this.connected_calendar_default_calendars_added = false;
          }

          //resetting to avoid duplicate notifications
          this.connect_status_notified = true;
          break;
        }
      }
    },
    update_add_bookings_to_calendar_id() {
      let add_bookings_to_calendar_id = this
        .tmp_edit_add_bookings_to_calendar_id;
      if (this.tmp_edit_add_bookings_to_calendar_account_id == "no") {
        add_bookings_to_calendar_id = "no";
      }
      let action = "update_add_bookings_to_calendar_id_for_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = {
        add_bookings_to_calendar_id: add_bookings_to_calendar_id
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            success_msg: "Settings saved."
          });
          if (response.data && response.data[action].hasOwnProperty("status")) {
            this.load_page();
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.$modal.hide("choose_add_bookings_to_calendar_modal");
    },
    update_conflict_calendar_ids() {
      let action = "update_conflict_calendar_ids_for_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = {
        conflict_calendar_ids: this.tmp_edit_conflict_calendar_ids,
        conflict_calendar_ids_length: this.tmp_edit_conflict_calendar_ids.length
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            success_msg: this.T__("Settings saved.")
          });
          if (response.data && response.data[action].hasOwnProperty("status")) {
            this.load_page();
            if (response.data && response.data[action].status === "success") {
              this.sync_all_calendar_api();
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.$modal.hide("choose_conflict_calendars_modal");
    },
    disconnect_calendar_by_id(calendar_account, force = false) {
      let action = "disconnect_calendar_by_id_for_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = {
        calendar_account_id: calendar_account.id,
        provider: calendar_account.provider,
        force: force === true ? "force_remove" : ""
      };

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          this.notify_single_action_result(response.data[action], {
            success_msg: this.T__("Calendar is disconnected successfully.")
          });

          if (
            !force &&
            response.data[action] &&
            response.data[action].hasOwnProperty("status") &&
            response.data[action].status == "error"
          ) {
            setTimeout(() => {
              this.show_disconnect_confirmation(calendar_account, true);
            }, 1000);
          }

          this.load_page();
        })
        .catch(error => {
          console.log(error);
        });
    },
    show_disconnect_confirmation(calendar_account, force = false) {
      let dialog_text;
      let yes_button_title;

      if (force) {
        dialog_text = this.Tsprintf(
          /* translators: 1: html-tag 2: html-tag-open 3: html-tag-close 4: account email */
          this.T__(
            "Oops! Error while disconnecting the account. %1$s Do want to %2$sforce-disconnect%3$s the %1$s %2$s %4$s %3$s account?"
          ),
          "<br>",
          "<strong>",
          "</strong>",
          calendar_account.account_email
        );
        yes_button_title = this.T__("Yes, force-disconnect.");
      } else {
        dialog_text = this.Tsprintf(
          /* translators: 1: html-tag 2: html-tag-open 3: html-tag-close 4: account email */
          this.T__(
            "Are you sure you want to disconnect the %1$s %2$s %4$s %3$s account?"
          ),
          "<br>",
          "<strong>",
          "</strong>",
          calendar_account.account_email
        );
        yes_button_title = this.T__("Yes, disconnect.");
      }

      this.$modal.show("dialog", {
        title: this.T__("Disconnect account?"),
        text: dialog_text,
        buttons: [
          {
            title: yes_button_title,
            class: "vue-dialog-button dialog-red-btn",
            handler: () => {
              this.disconnect_calendar_by_id(calendar_account, force);
              this.$modal.hide("dialog");
            }
          },
          {
            title: this.T__("No, cancel."),
            default: true // Will be triggered by default if 'Enter' pressed.
          }
        ]
      });
    },
    show_choose_add_bookings_to_calendar_modal() {
      //this.hide_default_calendars_added_onboard_modal();
      this.tmp_edit_add_bookings_to_calendar_account_id = this.add_bookings_to_calendar_account_id;
      this.tmp_edit_add_bookings_to_calendar_id = this.add_bookings_to_calendar_id;
      this.can_show_choose_add_bookings_to_calendar_modal = true;
      this.$modal.show("choose_add_bookings_to_calendar_modal");
    },
    show_choose_conflict_calendars_modal() {
      //this.hide_default_calendars_added_onboard_modal();
      this.tmp_edit_conflict_calendar_account_id = this.conflict_calendar_account_id;
      this.tmp_edit_conflict_calendar_ids = this.conflict_calendar_ids;
      this.can_show_choose_conflict_calendars_modal = true;
      this.$modal.show("choose_conflict_calendars_modal");
    },
    set_default_conflict_calendar_account_id() {
      for (let calendar_account_id in this.calendar_accounts) {
        if (this.conflict_calendar_ids.length == 0) {
          this.conflict_calendar_account_id = calendar_account_id;
          break;
        }

        for (let calendar_id in this.calendar_accounts[calendar_account_id]
          .calendars) {
          if (this.conflict_calendar_ids.indexOf(calendar_id) !== -1) {
            this.conflict_calendar_account_id = calendar_account_id;
            return;
          }
        }
      }
    },
    choose_default_calendar_for_add_bookings_to() {
      if (
        !this.tmp_edit_add_bookings_to_calendar_account_id ||
        this.tmp_edit_add_bookings_to_calendar_account_id == "no"
      ) {
        return;
      }

      if (this.tmp_edit_add_bookings_to_calendar_id) {
        //check calendar_id belongs to calendar_account_id
        if (
          this.is_calendar_id_belongs_to_calendar_account_id(
            this.tmp_edit_add_bookings_to_calendar_id,
            this.tmp_edit_add_bookings_to_calendar_account_id
          )
        ) {
          return;
        }
        this.tmp_edit_add_bookings_to_calendar_id = "";
      }

      if (
        !this.calendar_accounts[
          this.tmp_edit_add_bookings_to_calendar_account_id
        ] ||
        !this.calendar_accounts[
          this.tmp_edit_add_bookings_to_calendar_account_id
        ].calendars
      ) {
        return;
      }

      let first_calendar_id;
      for (let index in this.calendar_accounts[
        this.tmp_edit_add_bookings_to_calendar_account_id
      ].calendars) {
        let calendar = this.calendar_accounts[
          this.tmp_edit_add_bookings_to_calendar_account_id
        ].calendars[index];

        if (calendar.is_writable == "1") {
          first_calendar_id = calendar.id;
        }
        if (calendar.is_primary == "1") {
          this.tmp_edit_add_bookings_to_calendar_id = calendar.id;
          return;
        }
      }

      if (first_calendar_id) {
        this.tmp_edit_add_bookings_to_calendar_id = first_calendar_id;
        return;
      }
      return;
    },
    is_calendar_id_belongs_to_calendar_account_id(
      calendar_id,
      calendar_account_id
    ) {
      let is_exists = this.calendar_accounts[
        calendar_account_id
      ]?.calendars.hasOwnProperty(calendar_id);

      return is_exists ? true : false;
    },
    sync_all_calendar_api() {
      //current admin only

      //postpone manage_background_task
      this.$store.dispatch("manage_background_task", {
        initial_time_out: 30000 //30 secs
      });

      let action = "sync_all_calendar_api_for_current_admin";
      let wpcal_request = {};
      wpcal_request[action] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };

      axios
        .post(window.wpcal_ajax.ajax_url, post_data, {
          params: { _remove_options_before_call: { background_call: true } }
        })
        .then(response => {
          this.load_page();
        })
        .catch(error => {
          console.log(error);
        });
    },
    show_default_calendars_added_onboard_modal() {
      this.can_close_default_calendars_added_onboard = false;
      this.show_default_calendars_added_onboard = true;

      this.$nextTick(() => {
        const element = document.querySelector("#calendar_cofiguration_cont");
        const tooltip = document.querySelector(
          "#calendar_cofiguration_cont_tip"
        );

        this.default_calendars_added_onboard_popper_instance = createPopper(
          element,
          tooltip,
          {
            placement: "left",
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 5]
                }
              }
            ]
          }
        );

        this.$modal.show("default_calendars_added_onboard_overlay");
      });
    },
    hide_default_calendars_added_onboard_modal(hide_modal = true) {
      this.show_default_calendars_added_onboard = false;

      if (this.default_calendars_added_onboard_popper_instance) {
        this.default_calendars_added_onboard_popper_instance.destroy();
        this.default_calendars_added_onboard_popper_instance = null;
      }
      if (hide_modal) {
        this.$modal.hide("default_calendars_added_onboard_overlay");
      }
    },
    before_close_default_calendars_added_onboard_modal(event) {
      if (!this.can_close_default_calendars_added_onboard) {
        event.stop();
        return;
      }
      this.hide_default_calendars_added_onboard_modal(false); //false it already before close function it will be closed
    }
  },
  mounted() {
    this.load_page();

    setTimeout(() => {
      this.sync_all_calendar_api(); //Improve later - might create freq calls - should be rare admins visiting this page
    }, 1000);
  }
};
</script>

<style src="@/assets/css/admin_settings.css"></style>
<style>
#wpcal_admin_app ul.add-to-cal li label[for^="add-to-cal-opt"] {
  padding-left: 75px !important;
}
#wpcal_admin_app
  ul.add-to-cal
  li
  label[for^="add-to-cal-opt"].google_calendar::before {
  content: "";
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='186 38 76 76'%3E%3Cpath fill='%23fff' d='M244 56h-40v40h40V56z'/%3E%3Cpath fill='%23EA4335' d='M244 114l18-18h-18v18z'/%3E%3Cpath fill='%23FBBC04' d='M262 56h-18v40h18V56z'/%3E%3Cpath fill='%2334A853' d='M244 96h-40v18h40V96z'/%3E%3Cpath fill='%23188038' d='M186 96v12c0 3.315 2.685 6 6 6h12V96h-18z'/%3E%3Cpath fill='%231967D2' d='M262 56V44c0-3.315-2.685-6-6-6h-12v18h18z'/%3E%3Cpath fill='%234285F4' d='M244 38h-52c-3.315 0 -6 2.685-6 6v52h18V56h40V38z'/%3E%3Cpath fill='%234285F4' d='M212.205 87.03c-1.495-1.01-2.53-2.485-3.095-4.435l3.47-1.43c.315 1.2.865 2.13 1.65 2.79.78.66 1.73.985 2.84.985 1.135 0 2.11-.345 2.925-1.035s1.225-1.57 1.225-2.635c0-1.09-.43-1.98-1.29-2.67-.86-.69-1.94-1.035-3.23-1.035h-2.005V74.13h1.8c1.11 0 2.045-.3 2.805-.9.76-.6 1.14-1.42 1.14-2.465 0 -.93-.34-1.67-1.02-2.225-.68-.555-1.54-.835-2.585-.835-1.02 0 -1.83.27-2.43.815a4.784 4.784 0 0 0 -1.31 2.005l-3.435-1.43c.455-1.29 1.29-2.43 2.515-3.415 1.225-.985 2.79-1.48 4.69-1.48 1.405 0 2.67.27 3.79.815 1.12.545 2 1.3 2.635 2.26.635.965.95 2.045.95 3.245 0 1.225-.295 2.26-.885 3.11-.59.85-1.315 1.5-2.175 1.955v.205a6.605 6.605 0 0 1 2.79 2.175c.725.975 1.09 2.14 1.09 3.5 0 1.36-.345 2.575-1.035 3.64s-1.645 1.905-2.855 2.515c-1.215.61-2.58.92-4.095.92-1.755.005-3.375-.5-4.87-1.51zM233.52 69.81l-3.81 2.755-1.905-2.89 6.835-4.93h2.62V88h-3.74V69.81z'/%3E%3C/svg%3E");
  width: 20px;
  height: 20px;
  left: 45px;
  top: 12px;
}
#wpcal_admin_app .cal-provider {
  position: relative;
  padding-left: 20px;
  margin-left: 5px;
}
#wpcal_admin_app .cal-list .cal-provider.google_calendar::before {
  content: "";
  position: absolute;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='186 38 76 76'%3E%3Cpath fill='%23fff' d='M244 56h-40v40h40V56z'/%3E%3Cpath fill='%23EA4335' d='M244 114l18-18h-18v18z'/%3E%3Cpath fill='%23FBBC04' d='M262 56h-18v40h18V56z'/%3E%3Cpath fill='%2334A853' d='M244 96h-40v18h40V96z'/%3E%3Cpath fill='%23188038' d='M186 96v12c0 3.315 2.685 6 6 6h12V96h-18z'/%3E%3Cpath fill='%231967D2' d='M262 56V44c0-3.315-2.685-6-6-6h-12v18h18z'/%3E%3Cpath fill='%234285F4' d='M244 38h-52c-3.315 0 -6 2.685-6 6v52h18V56h40V38z'/%3E%3Cpath fill='%234285F4' d='M212.205 87.03c-1.495-1.01-2.53-2.485-3.095-4.435l3.47-1.43c.315 1.2.865 2.13 1.65 2.79.78.66 1.73.985 2.84.985 1.135 0 2.11-.345 2.925-1.035s1.225-1.57 1.225-2.635c0-1.09-.43-1.98-1.29-2.67-.86-.69-1.94-1.035-3.23-1.035h-2.005V74.13h1.8c1.11 0 2.045-.3 2.805-.9.76-.6 1.14-1.42 1.14-2.465 0 -.93-.34-1.67-1.02-2.225-.68-.555-1.54-.835-2.585-.835-1.02 0 -1.83.27-2.43.815a4.784 4.784 0 0 0 -1.31 2.005l-3.435-1.43c.455-1.29 1.29-2.43 2.515-3.415 1.225-.985 2.79-1.48 4.69-1.48 1.405 0 2.67.27 3.79.815 1.12.545 2 1.3 2.635 2.26.635.965.95 2.045.95 3.245 0 1.225-.295 2.26-.885 3.11-.59.85-1.315 1.5-2.175 1.955v.205a6.605 6.605 0 0 1 2.79 2.175c.725.975 1.09 2.14 1.09 3.5 0 1.36-.345 2.575-1.035 3.64s-1.645 1.905-2.855 2.515c-1.215.61-2.58.92-4.095.92-1.755.005-3.375-.5-4.87-1.51zM233.52 69.81l-3.81 2.755-1.905-2.89 6.835-4.93h2.62V88h-3.74V69.81z'/%3E%3C/svg%3E");
  width: 15px;
  height: 15px;
  left: 0px;
  top: 1px;
}
#wpcal_admin_app ul.selector.add-to-cal,
#wpcal_admin_app ul.selector.check-conflicts {
  max-height: 300px;
  overflow-x: auto;
  padding-bottom: 1px;
}
#wpcal_admin_app #calendar_cofiguration_cont.onboard-overlay-element {
  background-color: white;
  width: 358px;
}
#wpcal_admin_app .onboard-overlay-popper.popper-go-back {
  position: static !important;
}
</style>
